<template>
  <v-app>
    <!-- <NavBar /> -->

    <v-main>
      <!-- <Home />
      <WhatIs />
      <Benefits />
      <Discover />
      <Roadmap />
      <Join />
      <Team />
      <FAQ /> -->
      <ComingSoon />
      <!-- <Footer /> -->
    </v-main>
  </v-app>
</template>

<script>
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import WhatIs from "./components/WhatIs";
import Benefits from "./components/Benefits";
import Discover from "./components/Discover";
import Roadmap from "./components/Roadmap";
import Team from "./components/Team";
import Footer from "./components/Footer";
import FAQ from "./components/FAQ";
import ComingSoon from "./components/ComingSoon";
import Join from "./components/Join";

export default {
  name: "App",

  components: {
    Home,
    NavBar,
    Benefits,
    WhatIs,
    Discover,
    Roadmap,
    Team,
    Footer,
    FAQ,
    ComingSoon,
    Join,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Readex+Pro:wght@300;400;500;700&display=swap");
@font-face {
  font-family: "MadeOuter";
  src: local("MadeOuter"),
    url(./assets/made_outer_sans/MADE Outer Sans Medium PERSONAL USE.otf)
      format("truetype");
}
html {
  scroll-padding-top: 80px; /* height of sticky header */
  scroll-behavior: smooth;
}
@media screen and (max-width: 961px) {
  html {
    scroll-padding-top: 56px; /* height of sticky header */
  }
}
* {
  font-family: "MadeOuter", sans-serif;
}
</style>
